import {
	GET_ICD_CODES,
	GET_ICD_CODES_SUCCESS,
	GET_ICD_CODES_FAIL,
	GET_ICD_CODES_RESET,
} from '../actions/getIcdCodesAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getIcdCodesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ICD_CODES:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_ICD_CODES_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_ICD_CODES_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_ICD_CODES_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getIcdCodesReducer;
